export default function VPNService() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Military-Grade Security',
      description: 'Your data is protected with AES 256-bit encryption, the same standard used by governments and security experts worldwide to safeguard classified information.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Server Network',
      description: 'Access content from anywhere with our extensive network of high-speed servers strategically located across 50+ countries for optimal performance.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Lightning Fast Speed',
      description: 'Experience blazing-fast connection speeds without compromising security. Stream, download, and browse without buffering or slowdowns.'
    },
    {
      icon: 'ri-lock-line',
      title: 'Zero-Logs Policy',
      description: 'We never track, collect, or share your private data. Your online activity remains completely private and anonymous at all times.'
    }
  ];

  return (
    <section className="bg-white py-32">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-6 px-5 py-2 bg-[#00D9FF] rounded-full">
            <span className="text-white text-xs font-semibold uppercase tracking-wider whitespace-nowrap">OUR SERVICE</span>
          </div>
          <h2 className="text-6xl font-bold text-[#0A1628] mb-6">Professional VPN Protection</h2>
          <p className="text-[#5A6B7F] text-lg max-w-2xl mx-auto leading-relaxed">
            Secure your internet connection with our advanced VPN technology designed to protect your privacy and give you complete online freedom
          </p>
        </div>

        <div className="grid grid-cols-2 gap-16 items-center mb-20">
          <div className="rounded-3xl overflow-hidden h-[600px]">
            <img 
              src="https://public.readdy.ai/ai/img_res/42a2351d2e5ac3564bec519ccc456796.jpg" 
              alt="VPN Security Visualization" 
              className="w-full h-full object-cover"
            />
          </div>

          <div className="space-y-8">
            {features.map((feature, index) => (
              <div key={index} className="flex gap-6 items-start">
                <div className="flex-shrink-0 w-16 h-16 bg-[#00D9FF] rounded-full flex items-center justify-center">
                  <i className={`${feature.icon} text-2xl text-white`}></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-[#0A1628] mb-3">{feature.title}</h3>
                  <p className="text-[#6B7A8F] text-base leading-relaxed max-w-md">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-[#F5F7FA] rounded-2xl py-10">
          <div className="grid grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-5xl font-bold text-[#00D9FF] mb-2">256-bit</div>
              <div className="text-sm text-[#5A6B7F] uppercase tracking-wide whitespace-nowrap">Encryption</div>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold text-[#00D9FF] mb-2">50+</div>
              <div className="text-sm text-[#5A6B7F] uppercase tracking-wide whitespace-nowrap">Server Locations</div>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold text-[#00D9FF] mb-2">24/7</div>
              <div className="text-sm text-[#5A6B7F] uppercase tracking-wide whitespace-nowrap">Support</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
